import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
    loaderContainer: {
        height: '200px',
        width: '600px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}));
